@if (isAliasSelected ) {
  <div class="profile-section">
    <div [ngClass]="isprofileswitchselected?'disp-none':'name-email'">
      <ul>
        <li>
          <p>{{userName}}</p>
          @if (userEmail) {
            <p class="email">{{userEmail}}</p>
          }
        </li>
      </ul>
    </div>
    <div>
      <app-group-section ></app-group-section>
    </div>
    <div [ngClass]="isprofileswitchselected?'disp-none':'logout'" role="button" (click)="logout()">{{'BP_PM_LOGOUT'| translate }}</div>
  </div>
} @else {
  <div class="logout-section" role="button" (click)="logout()">{{'BP_PM_LOGOUT'| translate }}</div>
}

